import React from 'react';
import PropTypes from 'prop-types';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';
import Image from 'marketing-website/components/modules/Image';

import assets from 'marketing-website/configs/pages/features/design/assets.js';

export default function ToolsBlock({ color }) {
  return (
    <PageWrap size="l">
      <Spacing sizeМ="xl" type="padding" position="topBottom">
        <Grid columns={12}>
          <GridItem columnSpan={12} columnSpanM={6} alignContent="center">
            <MediaMultipleImages
              fallbackImageAlt={assets.extraFallback.alt}
              fallbackImageSrc={assets.extraFallback.src}
              fallbackImageMaxWidth={assets.extraFallback.maxWidth}
            >
              <Shape type="rectangle" color={color} width={460} height={320}>
                <Pattern
                  type="shortRectangle"
                  color={color}
                  top="6%"
                  left="6%"
                />
              </Shape>
              <ParallaxWrapper>
                <Image
                  {...assets.picker}
                  maxWidth={240}
                  position="absolute"
                  borderRadius="l"
                  top="38%"
                  left="8%"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={1.4}>
                <Image
                  {...assets.rightClick}
                  alt="Design interfaces"
                  borderRadius="m"
                  maxWidth={238}
                  position="absolute"
                  top="42%"
                  right="8%"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={2}>
                <Image
                  {...assets.grouping}
                  borderRadius="m"
                  maxWidth={240}
                  position="absolute"
                  top="20%"
                  left="28%"
                />
              </ParallaxWrapper>
            </MediaMultipleImages>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={6} alignContent="center">
            <HeadingBlock
              justifyContent="center"
              justifyM="flex-end"
              title="Feel like a professional designer"
              copy={
                <span>
                  Complex online design tools have created an intimidating
                  stigma around the practice. We’re challenging that.
                  <br />
                  <br />
                  With our accessible library of templates and assets, we’re
                  taking the complexity out of design. Meaning individuals can
                  jump in with ease and teams like content, marketing and sales
                  can work alongside the design team effortlessly.
                </span>
              }
              maxWidth={480}
            />
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}

ToolsBlock.propTypes = {
  color: PropTypes.string,
};

ToolsBlock.defaultProps = {
  color: null,
};



// WEBPACK FOOTER //
// ./src/pages/features/design/ToolsBlock.js